import { FC, useCallback, useEffect, useState } from 'react'
import { Outlet, useOutlet, useLocation, useParams, useSearchParams, useNavigate } from 'react-router-dom'
import { actionTypes, useStoreDispatch, useStoreState } from '@/store'
import { getLoginStatus } from '@/api/user'
import { PageLoading } from '@/components/PageLoading'
import { getCenterConfigApi } from '@/api/home'
import { withTitle } from '@/hoc/withTitle'
import { isEmpty, isInnerOpen, getUrlParam } from '@/utils'
import { getLngToApi } from '@/utils/getLng'
import { getIsPopUp } from '@/pages/user/baseInfo'
import { AliveScope, KeepAlive } from 'react-activation'
import LoginModal from '@/components/business/LoginModal/LoginModal'

export const Layout: FC = withTitle(props => {
  const dispatch = useStoreDispatch();
  const { isFirst, role, user, hwLoginModalOpen }: any = useStoreState()
  const { gameCode = '' } = useParams();
  const [loading, setLoading] = useState(true);
  const [configLoading, setConfigLoading] = useState(true);
  const location = useLocation();
  const outlet = useOutlet()
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate();
  
  // 隐藏登录弹窗
  const hideLogin = useCallback(() => {
    dispatch({ type: actionTypes.SET_HW_LOGIN_MODAL, payload: false });
    navigate(`/${gameCode ?? ''}`);
  }, [gameCode, navigate, dispatch]);

  // 初始化时如果有token则获取用户信息
  useEffect(() => {
    // 海外版本：检查是否需要显示登录弹框
    if (process.env.REACT_APP_IDN_ENV === 'hw') {
      const hasToken = localStorage.getItem('token');
      
      // 检查是否有免登参数
      const userInfo = getUrlParam('userInfo') || getUrlParam('userinfo');
      const ticket = getUrlParam('ticket');
      const hasAutoLoginParams = !!(userInfo || ticket);
      
      if (!hasToken) {
        // 如果有免登参数，延迟弹框，给免登逻辑执行的时间
        if (hasAutoLoginParams) {
          // 等待 2 秒，让免登逻辑有时间执行
          setTimeout(() => {
            // 再次检查 token，如果还是没有才弹框
            if (!localStorage.getItem('token')) {
              // dispatch({ type: actionTypes.SET_HW_LOGIN_MODAL, payload: true });
            }
          }, 2000);
          return setLoading(false);
        }
        
        // 没有免登参数，直接弹框
        // dispatch({ type: actionTypes.SET_HW_LOGIN_MODAL, payload: true });
        return setLoading(false);
      }
      
      // 有 token，验证是否有效
      const checkLogin = async () => {
        const res = await getLoginStatus().finally(() => setLoading(false))
        if (res?.code === 0) {
          dispatch({ type: actionTypes.SET_USER, payload: res.data });
        } else {
          // token 无效，打开登录弹框
          dispatch({ type: actionTypes.SET_HW_LOGIN_MODAL, payload: true });
        }
      }
      checkLogin();
      return;
    }
    
    // 国内版本：原有逻辑
    if (!localStorage.getItem('token')) return setLoading(false);
    const checkLogin = async () => {
      const res = await getLoginStatus().finally(() => setLoading(false))
      if (res?.code === 0) dispatch({ type: actionTypes.SET_USER, payload: res.data });
    }
    checkLogin();
  }, [dispatch]);

  // 海外版本：登录成功后自动关闭弹框
  useEffect(() => {
    if (process.env.REACT_APP_IDN_ENV === 'hw' && user.isLogin) {
      dispatch({ type: actionTypes.SET_HW_LOGIN_MODAL, payload: false });
    }
  }, [user.isLogin, dispatch]);

  // 初始化判断有没缓存游戏信息，如果有则检测gameCode 不一致则清除缓存的游戏信息
  useEffect(() => {
    let role: any = localStorage.getItem('role');
    if (role) {
      role = JSON.parse(role);
      if (isEmpty(role) || (gameCode && role.gameCode !== gameCode)) {
        localStorage.removeItem('role');
      } else {
        dispatch({ type: actionTypes.SET_ROLE, payload: role });
      }
    }

    /* 获取是否第一次弹窗 */
    if (localStorage.getItem('token') && isFirst && process.env.REACT_APP_IDN_ENV === 'hw') {
      console.log('isFirst', isFirst)
      getIsPopUp({
        callBack: (res) => {
          dispatch(res)
        }
      })
    }
  }, []);

  // 初始化需要获取客服中心配置 因为有些页面需要id来获取数据
  useEffect(() => {
    const getConfig = async () => {
      const res = await getCenterConfigApi({ gameCode, language: getLngToApi() }).finally(() => setConfigLoading(false));
      if (res?.code === 0) dispatch({ type: actionTypes.SET_CENTER_CONFIG, payload: res.data });
    }
    getConfig();
  }, []);

  // 判断是否是内部打开
  useEffect(() => {
    const type = parseInt(searchParams.get('type')) || null
    const kfId = parseInt(searchParams.get('kfId')) || null

    dispatch({ type: actionTypes.SET_INNER, payload: { type, kfId, isFrom: isInnerOpen(type) } });
  }, [])


  if (loading || configLoading) return <PageLoading />;

  return (
    <>
      <AliveScope>
        <KeepAlive cacheKey={location.key}>
          {outlet}
        </KeepAlive>
      </AliveScope>

      {/* 海外登录弹窗 */}
      {process.env.REACT_APP_IDN_ENV === 'hw' && (
      <LoginModal isOpen={hwLoginModalOpen} onClose={hideLogin} />
      )}
    </>
  )
})
